import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 All rights reserved | StockPhony</p>
    </footer>
  );
};

export default Footer;
